var parent = require('../../es/object/define-properties');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/stable/object/define-properties.js
// module id = 585
// module chunks = 0 1